import React from 'react';

import { withStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import styles from './styles';

export function DropdownItem(props) {
  const {
    className,
    title,
    description,
    titleSupport,
    hasIcon,
    iconContent,
    renderCustomIcon,
    classes
  } = props;

  return (
    <div data-testid="dropdown-item" className={clsx(classes.root, className)}>
      {renderCustomIcon
        ? renderCustomIcon()
        : hasIcon && (
            <div
              data-testid="default-icon"
              className={clsx(classes.defaultIcon, 'Dropdown-Item-Icon')}
            >
              {iconContent}
            </div>
          )}
      <div className={clsx(classes.content, 'Dropdown-Item-Content')}>
        <div
          className={clsx(
            classes.titleContainer,
            'Dropdown-Item-Title-Container'
          )}
        >
          <div>{title}</div>
          <div>{titleSupport}</div>
        </div>
        <div className={clsx(classes.description, 'Dropdown-Item-Description')}>
          {description}
        </div>
      </div>
    </div>
  );
}

DropdownItem.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object,
  /** Main content for dropdown item */
  title: PropTypes.string,
  /** Support content left aligned */
  titleSupport: PropTypes.string,
  /** Content underneath title */
  description: PropTypes.string,
  /** Change default icon color */
  iconColor: PropTypes.string,
  /** Boolean required to show icon */
  hasIcon: PropTypes.bool,
  /** Default icon inner content */
  icconContent: PropTypes.node,
  /** Custom Icon instead of default */
  renderCustomIcon: PropTypes.func
};

export default withStyles(styles)(DropdownItem);
